import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ChangeDate = styled.div`
  margin-top: 50px;
`;

export const SelectDateWrapper = styled.div`
  margin-top: 20px;

  ${media.md`
    max-width: 270px;
  `}
`;
